<template>
  <div class="bottom_menu_div">
    <div onclick="location.href='/main'" class="menu_div">
      <div class="img"><img id="icon_main" :src="switchIcon ? 'images/basic/menu_icon/tabbar-thehae-on.svg' : 'images/basic/menu_icon/tabbar-thehae.svg' " alt=""></div>
      <p>더해</p>
    </div>
    <div onclick="location.href='/mining'" class="menu_div">
      <div class="img"><img id="icon_mining" src="images/basic/menu_icon/tabbar-mining.svg" alt=""></div>
      <p>채굴</p>
    </div>
    <div onclick="location.href='/event'" class="menu_div">
      <div class="img"><img id="icon_event" src="images/basic/menu_icon/icon-tabbar-event.svg" alt=""></div>
      <p>이벤트</p>
    </div>
  <!--  <div onclick="location.href='/shopping'" class="menu_div">-->
  <!--    <div class="img"><img id="icon_shopping" src="images/basic/menu_icon/tabbar-shopping.svg" alt=""></div>-->
  <!--    <p>쇼핑</p>-->
  <!--  </div>-->
    <div onclick="location.href='/community'" class="menu_div">
      <div class="img"><img id="icon_community" src="images/basic/menu_icon/tabbar-community.svg" alt=""></div>
      <p>커뮤니티</p>
    </div>
    <div onclick="location.href='/more'" class="menu_div">
      <div class="img"><img id="icon_more" src="images/basic/menu_icon/tabbar-themore.svg" alt=""></div>
      <p>더해볼것</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    switchIcon: {
      type: Boolean
    }
  },
  created() {
  },
  mounted() {
    
  },
}
</script>

<style>

</style>